// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2SMy1","ranges":"BmiRanges_ranges__3gGkR"};